import React from 'react'
import { Button, Form, Typography, Input } from 'antd'
import PropTypes from 'prop-types'

import { loginWithEmailRules } from './rules'
import { LoginPanel } from '../styled'

const LoginWithEmailForm = ({ onSubmit }) => (
  <Form onFinish={onSubmit} preserve={false}>
    <LoginPanel>
      <Typography.Title>AutoEat - FoodStyles</Typography.Title>
      <Form.Item
        label="Email Address"
        name="email"
        rules={loginWithEmailRules.emailAddress}
      >
        <Input style={{ width: '300px' }} placeholder="Email Address..." />
      </Form.Item>
      <Form.Item
        label="Security Code"
        name="code"
        rules={loginWithEmailRules.securityCode}
      >
        <Input style={{ width: '300px' }} placeholder="Security Code..." />
      </Form.Item>
      <Button type="primary" htmlType="submit">
        Login
      </Button>
    </LoginPanel>
  </Form>
)

LoginWithEmailForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
}

export default LoginWithEmailForm
